if (typeof CollectionDescription !== 'function') {
  class CollectionDescription extends HTMLElement {
    constructor() {
      super();

      this.content = this.querySelector('[data-collection-description-content]');
      this.toggle = this.querySelector('[data-collection-description-toggle]');
      this.moreLabel = this.querySelector('[data-collection-description-more]');
      this.lessLabel = this.querySelector('[data-collection-description-less]');
      this.collapsedLines = parseInt(this.dataset.collapsedLines, 10) || 6;
      this.expanded = false;
      this.resizeTimer = null;

      if (!this.content || !this.toggle) return;

      this.toggle.addEventListener('click', () => this.toggleContent());
      window.addEventListener('resize', () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => this.update(), 150);
      });

      requestAnimationFrame(() => this.update());
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => this.update());
      }
    }

    getCollapsedHeight() {
      const styles = window.getComputedStyle(this.content);
      const fontSize = parseFloat(styles.fontSize) || 16;
      const lineHeight = parseFloat(styles.lineHeight) || fontSize * 1.5;

      return Math.ceil(lineHeight * this.collapsedLines);
    }

    update() {
      const fullHeight = this.content.scrollHeight;
      const collapsedHeight = this.getCollapsedHeight();
      const needsToggle = fullHeight > collapsedHeight + 1;

      this.toggle.hidden = !needsToggle;

      if (!needsToggle) {
        this.expanded = false;
        this.content.style.maxHeight = 'none';
        this.content.classList.remove('is-collapsed');
        this.toggle.setAttribute('aria-expanded', 'true');
        return;
      }

      this.content.style.maxHeight = this.expanded ? `${fullHeight}px` : `${collapsedHeight}px`;
      this.content.classList.toggle('is-collapsed', !this.expanded);
      this.toggle.setAttribute('aria-expanded', this.expanded ? 'true' : 'false');
      this.moreLabel.hidden = this.expanded;
      this.lessLabel.hidden = !this.expanded;
    }

    toggleContent() {
      this.expanded = !this.expanded;
      this.update();
    }
  }

  if (typeof customElements.get('collection-description') === 'undefined') {
    customElements.define('collection-description', CollectionDescription);
  }
}
